<template>
  <el-dialog
    class="modal"
    title="User Info"
    :close-on-click-modal="false"
    :visible="visible"
    @close="$emit('close', false)"
    width="1500px">
    <div class="dialog-title" slot="title">
      <i class="iconfont iconyonghuguanli"></i>
      {{ $t('accountManagement') }}
    </div>
    <div>
      <DropDown :data="accountStatus" :defaultVal="statusIndex" @select="handleSelect">
        <template v-slot:head>
          <el-button class="account-status">
            {{ accountStatus[statusIndex].name }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
        </template>
      </DropDown>
      <div class="key_words">
        <div class="key_input">
          <el-input v-model="keyWords" :placeholder="$t('porjectMsg')"></el-input>
        </div>
         <el-button type="primary" class="btn_search" @click="handleSearch">{{$t('search')}}</el-button>
      </div>
      <el-tooltip :content="$t('export')" placement="bottom">
        <i class="iconfont icon-daoru right-icon" @click="exportUserList"></i>
      </el-tooltip>
      <el-divider></el-divider>
      <Table
        :dataSource="dataSource"
        :columns="tableColumns"
      >
        <template #status>
          <el-table-column
            :width="110"
            :label="$t('state')"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.manualActive === false">
                {{ $t('inactivated') }}
              </template>
              <template v-else>
                {{ scope.row.available === false ? $t('disabled') : $t('activated') }}
              </template>
            </template>
          </el-table-column>
        </template>
        <template #lastLogin>
          <el-table-column
            :width="180"
            :label="$t('lastLoginDate')"
          >
            <template slot-scope="{ row }">
              {{ row.lastSignIntime && moment(row.lastSignIntime).format('YYYY-MM-DD HH:mm:ss') }}
            </template>
          </el-table-column>
        </template>
        <template #grantState>
          <el-table-column
            :width="110"
            :label="$t('stateApply')"
          >
            <template slot-scope="{ row }">
              {{ row.grantState ? $t('statusApply') :  $t('disabled') }}
            </template>
          </el-table-column>
        </template>
        <template #grantPermission>
          <el-table-column
            :width="150"
            :label="$t('applicationTime')"
          >
            <template slot-scope="{ row }">
              {{ row.grantPermission && moment(row.grantPermission).format('YYYY-MM-DD HH:mm:ss') }}
            </template>
          </el-table-column>
        </template>
          <template #lastModified>
          <el-table-column
            :width="180"
            :label="$t('creationTime')"
          >
            <template slot-scope="{ row }">
              {{ row.created && moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
            </template>
          </el-table-column>
        </template>
        <template #operation>
          <el-table-column
            :width="110"
            :label="$t('operation')"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" v-if="scope.row.manualActive === false" :content="$t('activate')" :hide-after="2000" placement="top">
                <i class="iconfont icon-jihuo pointer" style="margin-right: 8px; color: green" @click="activateAccount(scope.row.id)"></i>
              </el-tooltip>
              <template v-else>
                <el-tooltip class="item" effect="dark" :content="$t('disable')" :hide-after="2000" placement="top">
                  <i class="iconfont icon-weijihuo pointer" style="margin-right: 8px; color: red" v-if="scope.row.available === true" @click="disabledAccount(scope.row.id, 0)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('enable')" :hide-after="2000" placement="top">
                  <i class="iconfont icon-jihuo7 pointer" style="margin-right: 8px; color: green" v-if="scope.row.available === false" @click="disabledAccount(scope.row.id, 1)"></i>
                </el-tooltip>
              </template>
              <el-tooltip class="item" effect="dark" :content="$t('delete')" :hide-after="2000" placement="top">
                <i class="iconfont el-icon-delete pointer" @click="deleteAccount(scope.row.id)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </template>
      </Table>
      <Pagination
        v-if="dataSource.length > 0"
        :total="total"
        :pageSize="pageSize"
        :currentPage="pageNum"
        @change="getAccountListData"
        style="margin: 10px 5% 0;"
      />
    </div>
  </el-dialog>
</template>

<script>
import { getAccountList, availableAccounts, updateAccountIsAvailable, delAccount } from '../../api/user'
import { exportUser } from '../../api/importAndExport'
import config from '../../common/config'
import moment, { months } from 'moment'
import Cookies from 'js-cookie'

export default {
  name: 'accountManagement',
  props: {},
  data () {
    return {
      visible: true,
      dataSource: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      state: 0,
      moment: moment,
      keyWords: '',
      tableColumns: [{
        prop: 'loginName',
        label: this.$t('name'),
        width: '180'
      }, {
        prop: 'grantState',
        label: this.$t('stateApply'),
        slotName: 'grantState'
      }, {
        prop: 'grantPermission',
        label: this.$t('applicationTime'),
        slotName: 'grantPermission'
      }, {
        prop: 'email',
        label: this.$t('email'),
        showOverflowTooltip: true,
        width: '180'
      }, {
        prop: 'phone',
        label: this.$t('phone')
      }, {
        prop: 'customerId',
        label: this.$t('customerId')
      }, {
        prop: 'customerName',
        label: this.$t('customerName')
      }, {
        slotName: 'status',
        label: this.$t('state')
      }, {
        slotName: 'lastLogin'
      }, {
        slotName: 'lastModified',
        // label: this.$t('operation')
      }, {
        slotName: 'operation',
        label: this.$t('operation')
      }],
      statusIndex: 0,
      accountStatus: this.handleGlobalArr(config.accountStatus)
    }
  },
  mounted () {
    this.getAccountListData()
  },
  methods: {
    // 获取账号列表
    getAccountListData (pageObj = { pageNum: 1, pageSize: this.pageSize }) {
      const params = {
        pageNumber: pageObj.pageNum,
        pageSize: pageObj.pageSize,
        name: this.keyWords
      }
      if (this.statusIndex === 1) {
        params.available = 1
      } else if (this.statusIndex === 2) {
        params.manualActive = 0
        params.available = 1
      } else if (this.statusIndex === 3) {
        params.available = 0
      }
      getAccountList(params).then(res => {
        this.dataSource = res.data
        this.total = res.total
        this.pageSize = pageObj.pageSize
        this.pageNum = res.pageNum
      })
    },
    activateAccount (id) {
      const params = {
        userId: id,
        manualActive: 1
      }
      availableAccounts(params).then(res => {
        this.$message.success(this.$t('activateSuccess'))
        this.getAccountListData({ pageNum: this.pageNum, pageSize: this.pageSize })
      })
    },
    disabledAccount (id, available) {
      const params = {
        userId: id,
        available: available
      }
      updateAccountIsAvailable(params).then(res => {
        this.$message.success(this.$t(available === 0 ? 'disabledSuccess' : 'enabledSuccess'))
        this.getAccountListData({ pageNum: this.pageNum, pageSize: this.pageSize })
      })
    },
    handleSelect (data) {
      this.statusIndex = data.value
      this.getAccountListData()
    },
    deleteAccount (id) {
      this.$msgbox({
        title: this.$t('prompt'),
        message: this.$t('sureDelete'),
        showCancelButton: true,
        confirmButtonText: this.$t('sure'),
        cancelButtonText: this.$t('cancel'),
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            // instance.confirmButtonText = '执行中...'
            delAccount({
              userId: id
            }).then(res => {
              instance.confirmButtonLoading = false
              this.getAccountListData()
              done()
            })
          } else {
            done()
          }
        }
      }).then(action => {
      })
    },
    exportUserList () {
      const params = {
        userId: Cookies.get(config.userId)
      }
      if (this.statusIndex === 1) {
        params.available = 1
      } else if (this.statusIndex === 2) {
        params.manualActive = 0
        params.available = 1
      } else if (this.statusIndex === 3) {
        params.available = 0
      }
      exportUser(params).then(res => {
        this.$message.success(this.$t('deviceExportSuccess'))
      })
    },
    handleSearch () {
      this.getAccountListData()
    }
  }
}
</script>

<style lang="less" scoped>
.account-status {
  border: none;
  height: 40px;
  padding: 0 20px;
  border-radius: 40px;
  color: @color-primary;
  border: 1px solid @color-primary;
  background-color: #F3F5F9;
  .f-s-16();
}
.right-icon {
  font-size: 26px;
  float: right;
  position: relative;
  top: -22px;
  cursor: pointer;
}
.key_words{
    display: flex;
    position: absolute;
    top: 82px;
    left: 180px;
    .key_input{
      width: 180px;
      margin-right: 20px;
    }
    .btn_search{
      width: 55px;
      padding: 0 5px 0 5px;
    }
}
/deep/.el-input .el-input__inner {
    height: 36px;
}
</style>
